import { showConfirmBox, showMessageBox } from './msgbox';
import xhr from './xhr';

export function initXhrActions() {
    const targets = Array.from(document.querySelectorAll('a[data-url], button[data-url]'));
    for(const target of targets) {
        target.onclick = async () => {
            if(target.disabled)
                return;

            const url = target.dataset.url;
            if(typeof url !== 'string' || url.length < 1)
                return;

            const disableWithTarget = typeof target.dataset.disableWithTarget === 'string'
                ? (target.querySelector(target.dataset.disableWithTarget) ?? target)
                : target;
            const originalText = disableWithTarget.textContent;

            try {
                target.disabled = true;
                if(target.dataset.disableWith)
                    disableWithTarget.textContent = target.dataset.disableWith;

                if(target.dataset.confirm && !await showConfirmBox(target.dataset.confirm, 'Are you sure?'))
                    return;

                const { status, body } = await xhr.send(
                    target.dataset.method ?? 'GET',
                    url,
                    {
                        type: 'json',
                        authed: target.dataset.withAuth,
                        csrf: target.dataset.withCsrf,
                    }
                )

                if(status >= 400)
                    await showMessageBox(
                        body?.error?.text ?? `No additional information was provided. (HTTP ${status})`,
                        'Failed to complete action'
                    );
                else if(status >= 200 && status <= 299) {
                    if(target.dataset.refreshOnSuccess)
                        location.reload();
                    else {
                        const redirectUrl = target.dataset.redirectOnSuccess;
                        if(typeof redirectUrl === 'string' && redirectUrl.startsWith('/') && !redirectUrl.startsWith('//'))
                            location.assign(redirectUrl);
                    }
                }
            } catch(ex) {
                console.error(ex);
                await showMessageBox(ex, 'Failed to complete action');
            } finally {
                disableWithTarget.textContent = originalText;
                target.disabled = false;
            }
        };
    }
};
